module.exports = __webpack_public_path__ + "img/Antonia&Stephan-17.60ba3c50.jpg";